
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("gpWMx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.init = void 0;

var $bf3c94001b0a37f3$var$_jquery = $bf3c94001b0a37f3$var$_interopRequireDefault((parcelRequire("4kMWr")));
function $bf3c94001b0a37f3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $bf3c94001b0a37f3$var$init = module.exports.init = function init() {
    var attempts = 0;
    // if document.ready needed
    var _whenComplete = function whenComplete() {
        if (++attempts > 30) return;
        if (document.readyState === "complete") {
            (0, $bf3c94001b0a37f3$var$_jquery["default"])(".download-box-item .open-popup").on("click", function(e) {
                var target = (0, $bf3c94001b0a37f3$var$_jquery["default"])(e.target);
                var boxItem = target.closest(".download-box-item");
                (0, $bf3c94001b0a37f3$var$_jquery["default"])(".download-box-item").removeClass("popup-opened");
                boxItem.addClass("popup-opened");
            });
            (0, $bf3c94001b0a37f3$var$_jquery["default"])(".download-box-item .popup-container .close").on("click", function(e) {
                var target = (0, $bf3c94001b0a37f3$var$_jquery["default"])(e.target);
                var boxItem = target.closest(".download-box-item");
                boxItem.removeClass("popup-opened");
            });
            // On click outside of popup
            (0, $bf3c94001b0a37f3$var$_jquery["default"])(document).on("click", function(e) {
                if (!(0, $bf3c94001b0a37f3$var$_jquery["default"])(e.target).closest(".download-box-item.popup-opened").length) (0, $bf3c94001b0a37f3$var$_jquery["default"])(".download-box-item").removeClass("popup-opened");
            });
            // press escape to close popup
            (0, $bf3c94001b0a37f3$var$_jquery["default"])(document).on("keyup", function(e) {
                if (e.key === "Escape") (0, $bf3c94001b0a37f3$var$_jquery["default"])(".download-box-item").removeClass("popup-opened");
            });
            // collapsible toggle
            (0, $bf3c94001b0a37f3$var$_jquery["default"])(".download-material.is-accordeon .collapsible-header").on("click", function(e) {
                var parent = (0, $bf3c94001b0a37f3$var$_jquery["default"])(e.target).closest(".download-material");
                if (parent.hasClass("expanded")) parent.removeClass("expanded");
                else parent.addClass("expanded");
            });
        } else setTimeout(function() {
            return _whenComplete();
        }, 400);
    };
    _whenComplete();
};

});


//# sourceMappingURL=materialBoxRe.module.82be2088.js.map
